import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import Perencanaan from 'app/KinerjaDinasPage/pages/Perencanaan'
import PageGuardDinas from 'app/KinerjaDinasPage/components/PageGuardDinas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { School } from 'types/kinerja-ks'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-dinas-enabled'] &&
        toggle?.['kinerja-dinas-perencanaan-enabled']) ||
      false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    const npsn: School['npsn'] = (context?.query?.npsn ?? null) as string
    const ptkId: string = (context?.query?.ptkId ?? null) as string

    return {
      props: {
        npsn,
        ptkId,
      },
    }
  },
})

const Page: KinerjaApp = (
  props: PageProps & {
    npsn?: School['npsn']
    ptkId?: string
  }
) => (
  <PageGuardDinas>
    <Perencanaan {...props} />
  </PageGuardDinas>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
  pageTitle: 'Perencanaan Kinerja Pegawai',
}

export default Page
